import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  // View actions
  updateCurrentRequestId: ['requestId'],
  registerBse: ['operationNumber', 'origin', 'fields', 'UT'],
  // Reducer
  registerBseClear: null,
  registerBseRequest: null,
  registerBseSuccess: null,
  registerBseFailure: ['error']
});

export { Creators, Types };
